import Context from '../../common/context/context';


class MenuContext extends Context {

	constructor({name, root, popOnKey = 'esc', openClass = 'open', fixedClass = 'fixed', inClass = 'active'}) {
		super({name: name, root: root, popOnKey: popOnKey});
		this.openClass = openClass;
		this.fixedClass = fixedClass;
		this.inClass = inClass;
		this.nextSibling = null;
		this.parentNode = null;
	}


	beforeSwitchIn(otherContext) {
		return otherContext;
	}


	switchIn(otherContext) {
		const element = this.getElement();
		this.linkListener = this.events.on(element, 'a', 'click', this.onLinkClick.bind(this));
		this.classList(element).add(this.openClass);
		return this.threeStateTransition(element).add(this.inClass);
	}


	switchOut(otherContext) {
		const element = this.getElement();
		if (this.linkListener) {
			this.linkListener.destroy();
		}
		this.classList(element).add(this.fixedClass);
		this.classList(element).remove(this.openClass);

		return this.threeStateTransition(element).remove(this.inClass).then(() => {
			this.classList(element).remove(this.fixedClass);
			return otherContext;
		});
	}


	onLinkClick(event, target) {
		if (this.contexts.getCurrentContext() === this) {
			const href = target.getAttribute('href');
			if (href.charAt(0) !== '#' || !this.getElement().querySelector(href)) {
				event.preventDefault();
				this.contexts.pop().then(() => {
					target.click();
				});
			}
		}
	}

}


export default MenuContext;
